import { TransportInterface } from "../TransportInterface";

class NullTransport implements TransportInterface {

  public log(message: string): Promise<any> {
    return Promise.resolve(message);
  }

  public warn(message: string): Promise<any> {
    return Promise.resolve(message);
  }

  public debug(data: any, prefix: string): Promise<any> {
    return Promise.resolve([data, prefix]);
  }

  public logError(err: any): Promise<any> {
    return Promise.resolve(err);
  }
}

export { NullTransport };
